export default __webpack_public_path__ + "assets/images/reload-b9c4d74eae409fdf71e9adf31c1fc73e.svg";